<template>
  <v-row no-gutters>
    <v-col cols="12">
      <card-title-row
        is-subtitle
        translation-path="sidebar.relations"
        :has-buttons="false"
        :has-icon-column="false"
        class="pb-3"
      />
      <v-row no-gutters>
        <v-container>
          <v-row class="justify-start">
            <v-col v-for="(relation, idx) in relations" :key="idx" cols="auto" class="px-0 pr-3 py-0 pb-2">
              <v-chip color="rgba(0,0,0,0.08)" label small>
                <v-col cols="auto" class="px-0 zdm-relation-name">
                  {{ `${$i18n.t(`sidebar.zdmSingleObject.${relation.type}`)} ${relation.idx || ''}` }}
                </v-col>
                <v-col cols="auto" class="px-0 pl-1 zdm-relation-number">
                  {{ `(${relation.number || relation.name})` }}
                </v-col>
              </v-chip>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import CardTitleRow from '@/components/CardTitleRow';
export default {
  name: 'ZdmRelationWidget',
  components: {
    CardTitleRow,
  },
  props: {
    dataSource: {
      type: String,
      required: true,
    },
    featureId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    zdmDataSources: get('admin/modulesMapping@zdm_data.datasources'),
    zdmDataSourcesTypes() {
      const zdmDataSourcesTypes = {};
      for (const key of Object.keys(this.zdmDataSources)) {
        const dataSource = this.zdmDataSources[key].datasource;
        zdmDataSourcesTypes[dataSource] = key;
      }
      return zdmDataSourcesTypes;
    },
  },
  data: () => ({
    isFetched: false,
    relations: [],
  }),
  methods: {
    getRelations: call('zdm_data/getRelations'),
    async init() {
      this.isFetched = false;
      let data = await this.getRelations({ dataSource: this.dataSource, featureId: this.featureId });
      data = data.map(d => {
        return { ...d, type: this.zdmDataSourcesTypes[d.datasource] };
      });
      this.relations = data.map(d => {
        const dataByType = data.filter(da => da.type === d.type);
        const idx = dataByType.length > 1 ? dataByType.indexOf(d) + 1 : null;
        return { ...d, idx };
      });
      this.relations = this.relations.sort((a, b) =>
        this.$i18n.t(`sidebar.zdmSingleObject.${a.type}`) > this.$i18n.t(`sidebar.zdmSingleObject.${b.type}`) ? 1 : -1
      );
      this.isFetched = true;
    },
  },
  watch: {
    featureId() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.zdm-relation-name {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #202124;
}
.zdm-relation-number {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.59);
}
</style>
